import {AddPrefixToKeys} from "../../../../../common/util/ts-helpers";
import {VisibleLegsAction} from "../state";
import {DefaultState} from "./state";

const prefix = 'SCHED_TO_EXP_PAXCGO' as const;

function defineType<Name extends string>(name: Name){
    return `${prefix}.${name}` as `${typeof prefix}.${Name}`;
}

export const SET_VISIBLE = defineType('SET_VISIBLE');
export const SET_SELECTED_ENTITY_IDS = defineType('SET_SELECTED_ENTITY_IDS');
export const SET_STATUS = defineType('SET_STATUS');
export const SET_VISIBLE_LEGS = defineType('SET_VISIBLE_LEGS');

export type SchedToExpAction = {
    type: typeof SET_VISIBLE,
    payload: {
        open: boolean
    }
} | {
    type: typeof SET_SELECTED_ENTITY_IDS,
    add?: typeof DefaultState.selection.selectedEntityIds,
    remove?: typeof DefaultState.selection.selectedEntityIds,
    set?: typeof DefaultState.selection.selectedEntityIds
} | AddPrefixToKeys<VisibleLegsAction, `${typeof prefix}.`, 'type'> |
    {
        type: typeof SET_STATUS,
        payload: {
            status: 'LOADING' | 'SUCCESS'
        } | {
            status: 'ERROR',
            error: Error
        }
    }